import styled from '@emotion/styled';
import React from 'react';
import { Spacings, mediaQuery } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';

const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 1136px;
  margin: auto;
  padding: ${Spacings.SPACING_8B} ${Spacings.SPACING_0B};
  gap: 16px;
  ${mediaQuery.uptoMobile} {
    max-width: 360px;
    height: 80px;
    padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_4B}
      ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
    gap: ${Spacings.SPACING_4B};
    margin: ${Spacings.SPACING_0B};
  }
`;

const Filter = styled.div`
  height: ${Spacings.SPACING_10B};
  padding: ${Spacings.SPACING_10} ${Spacings.SPACING_5B};
  border-radius: ${Spacings.SPACING_2B};
  border: ${({ $isActive }) =>
    $isActive
      ? '1px solid var(--color-i-black)'
      : '1px solid var(--color-i-divider)'};
  cursor: pointer;
`;

const StyledTypography = styled(Typography)`
  line-height: ${Spacings.SPACING_4B};
`;

export const getFiltersApplied = (query) => {
  return {
    ...(query.type && { type: query.type })
  };
};

const FiltersTab = ({ filters, selectedFilter, handleChange }) => {
  return (
    <FiltersContainer>
      {filters.map((m, i) => (
        <Filter
          key={i}
          onClick={() => handleChange(m.key)}
          $isActive={selectedFilter === m.key}
        >
          <StyledTypography variant={selectedFilter === m.key ? 'h6' : 'p2'}>
            {m.label}
          </StyledTypography>
        </Filter>
      ))}
    </FiltersContainer>
  );
};

export default FiltersTab;
